import { InjectionToken } from '@angular/core';
import { SleipModalContent } from '@shared/models/modal-config.model';

export const SLEIP_MODAL_CONTENT = new InjectionToken<SleipModalContent>(
  'SLEIP_MODAL_CONTENT'
);

export const IS_HORSE_EDIT_FORM = new InjectionToken<boolean>(
  'IS_HORSE_EDIT_FORM'
);